import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Card} from '@betareader/design-system';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

import Icon from '../../components/AppIcon';
import ChapterFileUpload from '../content/chapter/upload/chapterFileUpload';

const Choices = styled(Card)`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 20px;
  padding: 24px;
  text-align: center;
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const CreateChoice = styled.div`
  display: grid;
  justify-items: center;
  gap: 12px;
  .mobile-create { display: none; }
  @media (max-width: 767px) {
    .desktop-create { display: none; }
    .mobile-create { display: inline-flex; }
  }
`;

const Steps = styled.ol`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 20px 0 0;
  padding: 0;
  list-style: none;
  li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 14px;
    border: 1px solid var(--br-border);
    border-radius: 8px;
    background: var(--br-surface);
  }
  strong { display: block; }
  @media (max-width: 767px) { display: none; }
`;

type Props = {
  onCreateManuscript(): void;
};

const CreateFirstBookSegment: React.FC<Props> = ({onCreateManuscript}) => {
  const {t} = useTranslation();
  return (
    <section>
      <h2>{t('YouDontHaveAnyManuscripts')}</h2>
      <Choices>
        <ChapterFileUpload
          createBook
          uploadHeader={t('ImportManuscript')}
          uploadMessage={t('ClickToUploadDoc')}
        />
        <span>{t('Or')}</span>
        <CreateChoice>
          <h3><Icon name="plus" /> {t('StartWriting')}</h3>
          <Button className="desktop-create" onClick={onCreateManuscript}>
            {t('CreateManuscript')}
          </Button>
          <Link className="br-button br-button--primary br-button--medium mobile-create" to="/books/new">
            {t('CreateManuscript')}
          </Link>
        </CreateChoice>
      </Choices>
      <Steps>
        <li><Icon name="upload" /><span><strong>{t('ImportManuscript')}</strong>{t('ImportManuscriptStepDescription')}</span></li>
        <li><Icon name="users" /><span><strong>{t('InviteReaders')}</strong>{t('InviteReadersStepDescription')}</span></li>
        <li><Icon name="comments outline" /><span><strong>{t('CollectFeedback')}</strong>{t('CollectFeedbackStepDescription')}</span></li>
      </Steps>
    </section>
  );
};

export default CreateFirstBookSegment;
